import { defineStore } from 'pinia'

export default defineStore({
  id: 'sellingPriceDataTable',
  persist: true,
  state: () => {
    return {
      isSellingPriceArchive: false
    }
  },
  actions: {
    setIsSellingPriceArchive: function (payload: boolean) {
      this.isSellingPriceArchive = payload
    }
  },
  getters: {
    getIsSellingPriceArchive: (state: any) => state.isSellingPriceArchive
  }
})
